import React from 'react'
import { Link } from 'react-router-dom'
import Linkdin from '../../assets/images/IN.png'
import Facebook from '../../assets/images/FB.png'
import X from '../../assets/images/X.png'
import Logo from '../../assets/images/Logo.png'

export default function Footer() {
    return (
        <footer>
            <div className='container'>
                <div className='flex flex-wrap top-footer row-gap-3 lg:row-gap-0'>
                    <div className='w-full md:w-6 lg:w-3'>
                        <div className='footer-title syne black-color text-base font-bold mb-3'>athena-io</div>
                        <ul className='karla opacity-50'>
                            <li><Link to="">How It Works</Link></li>
                            <li><Link to="">Pricing</Link></li>
                            <li><Link to="">Our Lawyers</Link></li>
                        </ul>
                    </div>
                    <div className='w-full md:w-6 lg:w-3'>
                        <div className='footer-title syne text-base font-bold mb-3 color-verdigris'>Get In Touch</div>
                        <ul className='karla opacity-50'>
                            <li><Link to="">Sign Up</Link></li>
                            <li><Link to="">Support</Link></li>
                            <li><Link to="">Contact Us</Link></li>
                        </ul>
                    </div>
                    <div className='w-full md:w-6 lg:w-3'>
                        <div className='footer-title syne color-verdigris text-base font-bold mb-3'>About Company</div>
                        <ul className='karla opacity-50'>
                            <li><Link to="">Our Story</Link></li>
                            <li><Link to="">Careers</Link></li>
                            <li><Link to="">Our Lawyers</Link></li>
                        </ul>
                    </div>
                    <div className='w-full md:w-6 lg:w-3'>
                        <ul className='karla gap-3 flex align-items-center lg:justify-content-end'>
                            <li><Link to=""><img src={Linkdin} alt='Linkdin'></img></Link></li>
                            <li><Link to=""><img src={Facebook} alt='Facebook'></img></Link></li>
                            <li><Link to=""><img src={X} alt='X'></img></Link></li>
                        </ul>
                    </div>
                </div>
                <div className='divider-footer opacity-60 border-bottom-1 '></div>
                <div className='flex flex-wrap row-gap-3 md:row-gap-0 align-items-center py-5 footer-bottom justify-content-between'>
                    <div className='footer-logo'>
                        <img src={Logo} alt='Athena' className='w-full block'></img>
                    </div>
                    <ul className='karla flex align-items-center gap-6'>
                        <li><Link to="">Terms</Link></li>
                        <li><Link to="">Privacy</Link></li>
                        <li><Link to="">Cookies</Link></li>
                    </ul>
                    <div></div>
                </div>
            </div>
        </footer>
    )
}
